module.exports = __webpack_public_path__ + "static/media/polygon_green.642b7fd1.svg";